module.exports = __webpack_public_path__ + "img/download.495213aa.svg";